import React, { memo, useCallback, useState } from 'react';
import classnames from 'classnames';
import styles from './GameRate.module.less';

export default memo(props => {
  const { score, rateInfo, primary, className, soft = false } = props;

  const star = `star`;
  const iconOn = 'icon-staron';
  const iconStaron = !primary ? iconOn : `${iconOn} icon-staron_commment`;
  const icon = soft ? 'icon-comt_star_lg' : 'icon-star';
  const iconStar = !primary ? icon : `${icon} icon-star_commment`;
  const starGrey = !primary
    ? `star_grey ${className}`
    : `star_grey star_grey_commment ${className}`;

  const starOnCount = Math.floor(Number(parseFloat(score) + 0.5)) || 0;

  return (
    <span className={styles.rate}>
      <span
        className={classnames(
          star,
          'iconfont',
          starOnCount >= 1 ? 'icon_achieve' : '',
          'icon-staron',
        )}
      />
      <span
        className={classnames(
          star,
          'iconfont',
          starOnCount >= 2 ? 'icon_achieve' : '',
          'icon-staron',
        )}
      />
      <span
        className={classnames(
          star,
          'iconfont',
          'icon-staron',
          starOnCount >= 3 ? 'icon_achieve' : '',
        )}
      />
      <span
        className={classnames(
          star,
          'iconfont',
          starOnCount >= 4 ? 'icon_achieve' : '',
          'icon-staron',
        )}
      />
      <span
        className={classnames(
          star,
          'iconfont',
          starOnCount >= 5 ? 'icon_achieve' : '',
          'icon-staron',
        )}
      />
    </span>
  );
});
